import axios from "axios";
import React, {useEffect, useState} from "react";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl} from '../Univ.js'
function ViewTest() {
    const [rows, setRows] = useState([]);
    const [tests, setTests] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        if (tests.length > 0) {
            setRows(tests);
        }
    }, [tests]);
    useEffect(() => {
        try {
            setIsLoading(true);
            axios.get(`${baseUrl}view-test/`)
                .then(response => {
                    setTests(response.data);
                    setIsLoading(false);
                });
        } catch (error) {
            console.log(error);
        }
    }, []);
    const handleDelete = (cat_id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    axios.delete(baseUrl + 'delete-test/' + cat_id)
                        .then(function (response) {
                            Swal.fire('success', 'Data has been Deleted');
                        });
                } catch (error) {
                    Swal.fire('error', 'Data has not been deleted');
                }
            } else {
                Swal.fire('error', 'Data has not been deleted');
            }
        })
    }
    const columns = [
        {field: 'id', headerName: 'Id', width: 70},
        {
            field: 'category',
            headerName: 'Category',
            width: 120,
            renderCell: (params) => params.row.subcat ? params.row.subcat.subcat : "N/A",
        },
        {
            field: 'subcat',
            headerName: 'Sub Category',
            width: 200,
            renderCell: (params) => params.row.subcat ? params.row.subcat.subcat : "N/A",
        },
        {field: 'test', headerName: 'Tests', width: 200},
        {field: 'sample', headerName: 'Sample', width: 140},
        {field: 'method', headerName: 'Method', width: 80},
        {field: 'ranges', headerName: 'Ranges', width: 140},
        {field: 'units', headerName: 'Units', width: 80},
        {field: 'ordering', headerName: 'Ordering No', width: 40},
        {
            field: 'edit', headerName: 'Edit',
            renderCell: (params) => (
                <Link to={`/edit-test/${params.row.id}`} target="_blank" className="btn btn-warning">
                    Edit
                </Link>
            ),
            width: 80
        },
        // { field: 'delete', headerName: 'Action',
        //   renderCell: (params) => (
        //     <button onClick={()=> handleDelete(params.row.id)} className="btn btn-danger btn-sm ms-1">
        //     <i className="fa-solid fa-trash-can"></i></button>
        // ),
        // width: 90 },
    ];
    return (
        <section className="container mt-4">
            {!isLoading && tests.length > 0 ? (
                <div style={{height: "100%", width: "100%"}}>
                    <DataGrid className="mt-4"
                              sx={{
                                  boxShadow: 4,
                                  border: 4,
                                  borderColor: 'primary.light',
                                  '& .MuiDataGrid-cell:hover': {
                                      color: 'primary.main',
                                  },
                              }}
                              pageSize={28}
                              rows={rows}
                              columns={columns}
                              components={{
                                  Toolbar: GridToolbar,
                              }}
                              autoHeight
                    />
                </div>
            ) : (
                <>loading pls wait....</>
            )}
        </section>
    )
}
export default ViewTest;